import { api } from '../../plugins/api';

const getDefaultState = () => {
	return {
		documents: []
	}
}

const state = getDefaultState()

const getters = {
	GET_ALL_DOCUMENTS: (state) => {
		return state.documents
	},
	GET_FORMATIONS_DOCUMENTS: (state) => { return state.documents.filter(d => d.label.startsWith("form")) },
	GET_FILTERED: (state, prefix) => { return state.documents.filter(d => d.label.startsWith(prefix)) }
}

const mutations = {
	SET_DOCUMENTS (state, documentsDTO) {
		state.documents = documentsDTO
	},
	REMOVE_DOCUMENT (state, encodedId) {
		// state.documents.splice(document);
		// state.documents = {...documents}
		state.documents.splice(state.documents.findIndex(d => d.id == encodedId), 1);
	},
	resetState (state) {
		Object.assign(state, getDefaultState())
	}
}

const actions = {
	async getDocumentsByContactId ({ commit }, encodedId) {
		const response = await api.get(`contacts/${encodedId}/documents`);
		commit('SET_DOCUMENTS', response.data ? response.data : [])
	},
	async getDocumentsByDemandeAdmissionId ({ commit }, encodedId) {
		const response = await api.get(`demandesadmissions/${encodedId}/documents`);
		commit('SET_DOCUMENTS', response.data ? response.data : [])
	},
	async getDocumentsByDemandeInscriptionId ({ commit }, encodedId) {
		const response = await api.get(`demandesinscriptions/${encodedId}/documents`);
		commit('SET_DOCUMENTS', response.data ? response.data : [])
	},
	async deleteDocumentByEncodedId ({ commit }, encodedId) {
		const response = await api.delete(`attachments/` + encodedId)
		if (response.data == true) {
			commit("REMOVE_DOCUMENT", encodedId)
		}
	},
	resetModuleState ({ commit }) {
		commit('resetState')
	},
}

export default ({
	namespaced: true,
	state: state,
	mutations: mutations,
	getters: getters,
	actions: actions
})